var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5133 8.03933L18.9767 7.57589C19.7446 6.80804 20.9895 6.80804 21.7574 7.57589C22.5252 8.34374 22.5252 9.58868 21.7574 10.3565L21.2939 10.82M18.5133 8.03933C18.5133 8.03933 18.5712 9.02414 19.4402 9.89309C20.3091 10.762 21.2939 10.82 21.2939 10.82M18.5133 8.03933L14.2527 12.2999C13.9641 12.5885 13.8198 12.7328 13.6957 12.8919C13.5493 13.0796 13.4238 13.2827 13.3214 13.4975C13.2346 13.6797 13.1701 13.8732 13.041 14.2604L12.6278 15.5L12.4942 15.901M21.2939 10.82L17.0333 15.0806C16.7447 15.3692 16.6004 15.5135 16.4413 15.6376C16.2537 15.7839 16.0506 15.9094 15.8357 16.0118C15.6536 16.0986 15.46 16.1632 15.0728 16.2922L13.8333 16.7054L13.4322 16.8391M13.4322 16.8391L13.0312 16.9728C12.8406 17.0363 12.6306 16.9867 12.4886 16.8447C12.3466 16.7027 12.297 16.4926 12.3605 16.3021L12.4942 15.901M13.4322 16.8391L12.4942 15.901",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33325 13H10.8333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33325 9H14.8333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33325 17H9.83325",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1617 3.17157C18.9901 2 17.1045 2 13.3333 2H11.3333C7.56202 2 5.6764 2 4.50482 3.17157C3.33325 4.34315 3.33325 6.22876 3.33325 10V14C3.33325 17.7712 3.33325 19.6569 4.50482 20.8284C5.6764 22 7.56202 22 11.3333 22H13.3333C17.1045 22 18.9901 22 20.1617 20.8284C21.1048 19.8853 21.2887 18.4796 21.3246 16",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocUpload);
export default __webpack_public_path__ + "static/media/docUpload.ba0757fac3b62468cab67b5c25ec5a25.svg";
export { ForwardRef as ReactComponent };